module.exports = __webpack_public_path__ + "static/media/estar.e409adfe.png";